export default function _isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
}


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/ramda/es/internal/_isObject.js
// module id = 191
// module chunks = 0 1 2 3 4 5 6 8